import { render, staticRenderFns } from "./IQCRecordList.vue?vue&type=template&id=2df9beff&scoped=true&"
import script from "./IQCRecordList.vue?vue&type=script&lang=js&"
export * from "./IQCRecordList.vue?vue&type=script&lang=js&"
import style0 from "./IQCRecordList.vue?vue&type=style&index=0&id=2df9beff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df9beff",
  null
  
)

export default component.exports